export default "__VITE_ASSET__Tp4jCnlb__"